import { ISnotrRoute } from '..';

export default [
  {
    path: '/paycheck-periods',
    name: 'PaycheckPeriods',
    meta: {
      title: 'TabTitle.paycheckPeriods',
      applicationMode: 'PaycheckMode',
    },
    component: () => import('@/pages/paycheck-periods.vue'),
  },
] as ISnotrRoute[];
